import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    ref: "chatHead",
    class: "z-mid white-dark-background"
};
const _hoisted_2 = { class: "row justify-between q-py-sm" };
const _hoisted_3 = { class: "absolute absolute-bottom-right receiver-margin" };
const _hoisted_4 = { class: "row full-height ellipsis-2-lines" };
const _hoisted_5 = { class: "self-end" };
const _hoisted_6 = {
    key: 0,
    class: "text-accent custom-text-b8"
};
const _hoisted_7 = {
    key: 1,
    class: "text-accent custom-text-b8"
};
const _hoisted_8 = { class: "row justify-start text-caption st-ht-20" };
const _hoisted_9 = {
    key: 0,
    class: "self-center text-primary"
};
const _hoisted_10 = { class: "row justify-center cursor-pointer text-center full-height" };
const _hoisted_11 = { class: "col-12 self-center" };
const _hoisted_12 = { class: "row justify-center" };
const _hoisted_13 = { class: "row justify-center cursor-pointer text-center full-height" };
const _hoisted_14 = { class: "col-12 self-center" };
const _hoisted_15 = { class: "row justify-center" };
const _hoisted_16 = { class: "row full-height" };
const _hoisted_17 = { class: "row st-wh-220" };
const _hoisted_18 = {
    key: 0,
    class: "col-12"
};
const _hoisted_19 = {
    key: 1,
    class: "col-12"
};
const _hoisted_20 = { class: "col-12" };
const _hoisted_21 = {
    key: 2,
    class: "col-12"
};
const _hoisted_22 = {
    key: 3,
    class: "col-12"
};
const _hoisted_23 = {
    key: 4,
    class: "col-12"
};
const _hoisted_24 = {
    key: 0,
    class: "q-pa-sm"
};
const _hoisted_25 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_tooltip = _resolveComponent("q-tooltip");
    const _component_standard_avatar = _resolveComponent("standard-avatar");
    const _component_q_item_section = _resolveComponent("q-item-section");
    const _component_q_item_label = _resolveComponent("q-item-label");
    const _component_q_slide_transition = _resolveComponent("q-slide-transition");
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_item = _resolveComponent("q-item");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_router_link = _resolveComponent("router-link");
    const _component_report = _resolveComponent("report");
    const _component_q_menu = _resolveComponent("q-menu");
    const _component_general_dialog = _resolveComponent("general-dialog");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_q_btn, {
                name: _ctx.backLabel,
                label: _ctx.backLabel,
                icon: "keyboard_arrow_left",
                "text-color": "primary",
                class: "font-weight-bold-important",
                size: "sm",
                flat: "",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close-chat')))
            }, null, 8, ["name", "label"])
        ]),
        _createVNode(_component_q_item, { class: "q-pt-none" }, {
            default: _withCtx(() => [
                _createVNode(_component_q_item_section, { avatar: "" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_standard_avatar, {
                            size: "3rem",
                            "default-alt": "Convo Receiver Pic",
                            "alt-alt": "Convo Default Receiver Pic",
                            "original-size": "profile",
                            "size-type": "profile",
                            "allow-other-formats": "",
                            pic: _ctx.convo.receiver_pic
                        }, {
                            badge: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass([{
                                                'bg-accent': !_ctx.receiverOnline && !_ctx.isTyping,
                                                'bg-positive': _ctx.receiverOnline || _ctx.isTyping
                                            }, "rounded st-wh-12 st-ht-12"])
                                    }, [
                                        _createVNode(_component_q_tooltip, null, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.receiverOnline || _ctx.isTyping ? 'online' : 'offline'), 1)
                                            ]),
                                            _: 1
                                        })
                                    ], 2)
                                ])
                            ]),
                            _: 1
                        }, 8, ["pic"])
                    ]),
                    _: 1
                }),
                _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_item_label, { class: "text-weight-bold st-ht-34" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, [
                                        (_ctx.listingIsActive.active === false)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " [inactive] "))
                                            : (_ctx.listingIsActive.approved === false)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, " [disabled] "))
                                                : _createCommentVNode("", true),
                                        _createTextVNode(" " + _toDisplayString(_ctx.convo.listing_name), 1)
                                    ])
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_item_label, {
                            caption: "",
                            class: "ellipsis-1-line grey8-white-text-color"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.convo.receiver_name), 1)
                            ]),
                            _: 1
                        }),
                        _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_q_slide_transition, null, {
                                default: _withCtx(() => [
                                    (_ctx.isTyping)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Typing... "))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ])
                    ]),
                    _: 1
                }),
                (!_ctx.isChatUser && (_ctx.appType === 'getspaces'))
                    ? (_openBlock(), _createBlock(_component_q_item_section, {
                        key: 0,
                        side: "",
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('create-custom-order'))),
                        style: { "max-width": "68px", "padding-left": "2px !important" }
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _createVNode(_component_q_btn, {
                                            round: "",
                                            unelevated: "",
                                            color: "positive",
                                            "text-color": "black",
                                            size: "10px",
                                            icon: "add_shopping_cart",
                                            loading: _ctx.listingLoading
                                        }, null, 8, ["loading"])
                                    ]),
                                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "custom-text-b8 row q-pt-sm full-width" }, [
                                        _createElementVNode("span", { style: { "height": "8px", "line-height": "0", "font-weight": "700 !important" } }, "Custom Order")
                                    ], -1))
                                ])
                            ])
                        ]),
                        _: 1
                    }))
                    : (_ctx.hostContact)
                        ? (_openBlock(), _createBlock(_component_q_item_section, {
                            key: 1,
                            side: "",
                            onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.hostContactShow = true)),
                            style: { "max-width": "68px", "padding-left": "2px !important" }
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("div", _hoisted_15, [
                                            _createVNode(_component_q_btn, {
                                                round: "",
                                                unelevated: "",
                                                color: "positive",
                                                "text-color": "black",
                                                size: "10px",
                                                icon: "call"
                                            })
                                        ]),
                                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "custom-text-b8 row q-pt-sm full-width" }, [
                                            _createElementVNode("span", { style: { "height": "8px", "line-height": "0", "font-weight": "700 !important" } }, " Host Contact ")
                                        ], -1))
                                    ])
                                ])
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                _createVNode(_component_q_item_section, {
                    side: "",
                    style: { "padding-left": "2px !important" }
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_q_btn, {
                                round: "",
                                flat: "",
                                dense: "",
                                icon: "more_vert",
                                class: "self-center"
                            }),
                            _createVNode(_component_q_menu, {
                                modelValue: _ctx.menu,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.menu) = $event))
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_17, [
                                        (!_ctx.isChatUser)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                _createVNode(_component_q_item, {
                                                    clickable: "",
                                                    onClick: _ctx.viewCalendar,
                                                    class: "q-pa-sm"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_q_item_section, {
                                                            side: "",
                                                            class: "q-pr-sm"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_q_icon, {
                                                                    name: "calendar_month",
                                                                    size: "sm"
                                                                })
                                                            ]),
                                                            _: 1
                                                        }),
                                                        _createVNode(_component_q_item_section, null, {
                                                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                                _createTextVNode(" View Calendar ", -1)
                                                            ])),
                                                            _: 1,
                                                            __: [9]
                                                        })
                                                    ]),
                                                    _: 1
                                                }, 8, ["onClick"]),
                                                _createVNode(_component_q_separator)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (!_ctx.isChatUser)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                _createVNode(_component_router_link, {
                                                    to: {
                                                        name: 'Host Upcoming Bookings',
                                                        query: {
                                                            order_guest_pk: _ctx.receiver
                                                        }
                                                    }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_q_item, {
                                                            clickable: "",
                                                            onClick: _ctx.checkDashboardRoute,
                                                            class: "q-pa-sm"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_q_item_section, {
                                                                    side: "",
                                                                    class: "q-pr-sm"
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_component_q_icon, {
                                                                            name: "list_alt",
                                                                            size: "sm"
                                                                        })
                                                                    ]),
                                                                    _: 1
                                                                }),
                                                                _createVNode(_component_q_item_section, null, {
                                                                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                                        _createTextVNode(" View Bookings ", -1)
                                                                    ])),
                                                                    _: 1,
                                                                    __: [10]
                                                                })
                                                            ]),
                                                            _: 1
                                                        }, 8, ["onClick"])
                                                    ]),
                                                    _: 1
                                                }, 8, ["to"]),
                                                _createVNode(_component_q_separator)
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_20, [
                                            _createVNode(_component_router_link, {
                                                to: {
                                                    name: _ctx.listingRedirect,
                                                    params: { id: _ctx.routeString }
                                                }
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_q_item, {
                                                        clickable: "",
                                                        onClick: _ctx.checkRoute,
                                                        class: "q-pa-sm"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_q_item_section, {
                                                                side: "",
                                                                class: "q-pr-sm"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_q_icon, {
                                                                        name: "apartment",
                                                                        size: "sm"
                                                                    })
                                                                ]),
                                                                _: 1
                                                            }),
                                                            _createVNode(_component_q_item_section, null, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(" View " + _toDisplayString(_ctx.listingRedirect), 1)
                                                                ]),
                                                                _: 1
                                                            })
                                                        ]),
                                                        _: 1
                                                    }, 8, ["onClick"])
                                                ]),
                                                _: 1
                                            }, 8, ["to"]),
                                            _createVNode(_component_q_separator)
                                        ]),
                                        (_ctx.isChatUser && _ctx.appType === 'getspaces')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                _createVNode(_component_router_link, {
                                                    to: {
                                                        name: 'Host Spaces For Rent',
                                                        params: { id: _ctx.isChatUser }
                                                    }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_q_item, {
                                                            clickable: "",
                                                            onClick: _ctx.checkProfileRoute,
                                                            class: "q-pa-sm"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_q_item_section, {
                                                                    side: "",
                                                                    class: "q-pr-sm"
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_component_q_icon, {
                                                                            name: "account_circle",
                                                                            size: "sm"
                                                                        })
                                                                    ]),
                                                                    _: 1
                                                                }),
                                                                _createVNode(_component_q_item_section, null, {
                                                                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                                                                        _createTextVNode(" View Host Profile ", -1)
                                                                    ])),
                                                                    _: 1,
                                                                    __: [11]
                                                                })
                                                            ]),
                                                            _: 1
                                                        }, 8, ["onClick"])
                                                    ]),
                                                    _: 1
                                                }, 8, ["to"]),
                                                _createVNode(_component_q_separator)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (_ctx.showShare)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                (!_ctx.$q.platform.is.capacitor || !_ctx.$q.platform.is.android)
                                                    ? (_openBlock(), _createBlock(_component_q_item, {
                                                        key: 0,
                                                        clickable: "",
                                                        onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.shareRoute(_ctx.listing))),
                                                        class: "q-pa-sm info-primary-variant-text-color"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_q_item_section, {
                                                                side: "",
                                                                class: "q-pr-sm"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_q_icon, {
                                                                        name: "share",
                                                                        class: "info-primary-variant-text-color",
                                                                        size: "sm"
                                                                    })
                                                                ]),
                                                                _: 1
                                                            }),
                                                            _createVNode(_component_q_item_section, null, {
                                                                default: _withCtx(() => _cache[12] || (_cache[12] = [
                                                                    _createTextVNode(" Share ", -1)
                                                                ])),
                                                                _: 1,
                                                                __: [12]
                                                            })
                                                        ]),
                                                        _: 1
                                                    }))
                                                    : (_openBlock(), _createBlock(_component_q_item, {
                                                        key: 1,
                                                        clickable: "",
                                                        onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.share(_ctx.listing))),
                                                        class: "q-pa-sm info-primary-variant-text-color"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_q_item_section, {
                                                                side: "",
                                                                class: "q-pr-sm"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_q_icon, {
                                                                        name: "share",
                                                                        class: "info-primary-variant-text-color",
                                                                        size: "sm"
                                                                    })
                                                                ]),
                                                                _: 1
                                                            }),
                                                            _createVNode(_component_q_item_section, null, {
                                                                default: _withCtx(() => _cache[13] || (_cache[13] = [
                                                                    _createTextVNode(" Share ", -1)
                                                                ])),
                                                                _: 1,
                                                                __: [13]
                                                            })
                                                        ]),
                                                        _: 1
                                                    })),
                                                (_ctx.isChatUser)
                                                    ? (_openBlock(), _createBlock(_component_q_separator, { key: 2 }))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (_ctx.isChatUser)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                _createVNode(_component_report, null, {
                                                    "report-btn": _withCtx(({ report }) => [
                                                        _createVNode(_component_q_item, {
                                                            clickable: "",
                                                            onClick: report,
                                                            class: "q-pa-sm"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_q_item_section, {
                                                                    side: "",
                                                                    class: "q-pr-sm"
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_component_q_icon, {
                                                                            name: "report",
                                                                            size: "sm"
                                                                        })
                                                                    ]),
                                                                    _: 1
                                                                }),
                                                                _createVNode(_component_q_item_section, null, {
                                                                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                                                                        _createTextVNode(" Report Bypass ", -1)
                                                                    ])),
                                                                    _: 1,
                                                                    __: [14]
                                                                })
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["onClick"])
                                                    ]),
                                                    _: 1
                                                })
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _: 1
                            }, 8, ["modelValue"])
                        ])
                    ]),
                    _: 1
                })
            ]),
            _: 1
        }),
        _createVNode(_component_general_dialog, {
            modelValue: _ctx.hostContactShow,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.hostContactShow) = $event)),
            title: "Host contact"
        }, {
            content: _withCtx(() => [
                (_ctx.hostContact)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        (_ctx.platformInfo.mobile || _ctx.platformInfo.isApp)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "self-center",
                                href: `tel:${_ctx.hostContact.host_contact_num_country_code || ''}${_ctx.hostContact.host_contact_num}`
                            }, [
                                _createVNode(_component_q_item, {
                                    clickable: "",
                                    dense: "",
                                    class: "q-pa-none"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_q_item_section, { side: "" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_q_icon, {
                                                    name: "phone",
                                                    color: "primary",
                                                    size: "24px",
                                                    class: "self-center q-pr-sm"
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_q_item_section, null, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.hostContact.host_contact_num_country_code
                                                    ? `${_ctx.hostContact.host_contact_num_country_code}-`
                                                    : '') + _toDisplayString(_ctx.hostContact.host_contact_num), 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_q_item_section, { side: "" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_q_icon, {
                                                    name: "chevron_right",
                                                    size: "24px",
                                                    class: "self-center"
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ], 8, _hoisted_25))
                            : (_openBlock(), _createBlock(_component_q_item, {
                                key: 1,
                                dense: "",
                                class: "q-pa-none"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_q_item_section, { side: "" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_q_icon, {
                                                name: "phone",
                                                color: "primary",
                                                size: "24px",
                                                class: "self-center q-pr-sm"
                                            })
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_q_item_section, null, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.hostContact.host_contact_num_country_code
                                                ? `${_ctx.hostContact.host_contact_num_country_code}-`
                                                : '') + _toDisplayString(_ctx.hostContact.host_contact_num), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }))
                    ]))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        }, 8, ["modelValue"])
    ], 512));
}
